/**
 * Visitor consent for the first-party analytics of the public surfaces
 * (`tour_sessions`/`tour_events` en `.360`, `tap_events` en `.tap`).
 *
 * Qué se mide: visitas agregadas para el dueño del tour/venue. **No hay cookies
 * de analítica, ni identificador persistente en el dispositivo, ni terceros** —
 * el id de sesión vive sólo en memoria (`services/analyticsSession.ts`). Por eso
 * la base legal es interés legítimo (GDPR art. 6.1.f) y la medición corre por
 * defecto; esto es el **opt-out** real: sólo un "denied" explícito la apaga.
 *
 * ponytail: un flag en localStorage, sin categorías ni CMP. Si algún día entra
 * un tercero (GA, Meta pixel, ads), esto pasa a opt-IN por categoría.
 */

const KEY = "andar-consent";
/** Clave del banner viejo (toast en AppContext). "true" = aceptado. */
const LEGACY_KEY = "cookie-consent";

export type Consent = "granted" | "denied";

function read(): Consent | null {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "granted" || v === "denied") return v;
    return localStorage.getItem(LEGACY_KEY) === "true" ? "granted" : null;
  } catch {
    // Safari private / storage bloqueado: sin decisión guardada.
    return null;
  }
}

/** Decisión guardada, o null si el visitante todavía no eligió. */
export function getConsent(): Consent | null {
  return read();
}

export function setConsent(value: Consent): void {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* storage bloqueado — la decisión vale sólo para esta vista */
  }
}

/** Falso sólo si el visitante rechazó explícitamente. */
export function analyticsAllowed(): boolean {
  return read() !== "denied";
}
